/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  rejectedFile: {
    id: 'AssetDropzoneField.rejectedFile',
    defaultMessage:
      'The file type, "{rejectedFileType}" is not supported. Please choose one of the following types: {accept}',
    description: 'The default error message for the rejected file.'
  },
  toggleSource: {
    id: 'AssetDropzoneField.button.title.toggleSource',
    defaultMessage: 'Toggle Source',
    description:
      'The default title for the AssetDropzoneField component toggle.'
  },
  deleteBtnTitle: {
    id: 'AssetDropzoneField.button.title.delete',
    defaultMessage: 'Delete',
    description: 'Title for the "Delete" button.'
  }
});
